import { ObjectId } from "./common";

export enum UserRoleName {
  USER = "User",
  ADMIN = "Administrator",
}

export enum RoleName {
  USER = "User",
  CONTRIBUTOR = "Contributor",
  MANAGER = "Manager",
}

export enum SubscriptionType {
  PLATFORM = "PLATFORM",
  ORION = "ORION",
  SIRIUS = "SIRIUS",
}

export interface UserRole {
  role: RoleName;
  subscription: SubscriptionType;
}
export interface UserRoles {
  role: UserRoleName;
  workspaces: Record<string, UserRole>;
}

export interface UserAttrs {
  email: string;
  first_name: string;
  last_name: string;
  metadata: Record<string, string> | null;
  role: UserRoleName;
}

export interface UserExtendedAttrs extends UserAttrs {
  _id: string;
  is_api_user: boolean;
  last_login: Date | null;
}

export interface UserWorkspaceRole {
  user_id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: UserRoleName;
  workspace_id: ObjectId;
  workspace_role: RoleName;
  workspace_added_at: Date;
  user_created_at: Date;
  user_last_activity: Date | null;
}

export interface Workspace {
  _id: ObjectId;
  name: string;
  description: string;
}

export interface Subscription {
  _id: ObjectId;
  type: SubscriptionType;
  orion_limit: number | null;
  sirius_limit: number | null;
  user_limit: number | null;
  starting_date: Date;
  ending_date: Date;
}
